export const customerHistory = ({dispatch}) => next => (action) => {
    next(action);
}
